import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-browser-com',
  templateUrl: './browser-com.component.html',
  styleUrls: ['./browser-com.component.css']
})
export class BrowserComComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
